export enum DeviceAccessoryStatus {
    inStock = 'inStock',
    sent = 'sent',
}
